// extracted by mini-css-extract-plugin
module.exports = {"locationTitleContainer":"location-title_locationTitleContainer__2ZApL"};